// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AG_Y","colMin":"styles_colMin__2zZQs"};